import { withInstall } from '@hd-front-end/utils'
import TreeSelect from './src/tree-select.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElTreeSelect: SFCWithInstall<typeof TreeSelect> =
  withInstall(TreeSelect)

export default ElTreeSelect
